/**
 * Styled Components - Created by david on 05/04/18.
 */
import styled from 'styled-components'
import {
  WHITE,
  BLACK,
  GRAY_DARK,
  RED,
  BLUE
} from '../../theme/colors'

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  background-color: ${WHITE};
  min-height: calc(100vh - 200px);
`

export const SideBar = styled.div`
  width: 20%;
  padding-top: 36px;
  padding-left: 26px;
`

export const OptionMenu = styled.div`
  color: ${GRAY_DARK};
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
  padding-top: 8px;
  cursor: pointer;
`

export const BetaLabel = styled.div`
  display: inline-block;
  font-size: 9px;
  color: #40ab6d;
  font-style: italic;
  margin-left: 4px;
  vertical-align: top;
  margin-top: -2px;
  font-weight: bold;
`

export const BetaLabelIcon = styled.div`
  display: inline-block;
  font-size: 9px;
  color: #40ab6d;
  font-style: italic;
  position: relative;
  margin-bottom: 7px;
  margin-top: -34px;
  margin-left: 39px;
`

export const NewLabel = styled.div`
  display: inline-block;
  font-size: 9px;
  color: ${RED};
  font-style: italic;
  margin-left: 4px;
  vertical-align: top;
  margin-top: -2px;
  font-weight: bold;
`

export const BadgeLabel = styled.div`
  background: red;
  width: 8px;
  height: 8px;
  border-radius: 6px;
  display: inline-block;
  vertical-align: top;
  margin-left: 8px;
  margin-top: -2px;
`

interface ContentProps {
  width?: string
}

export const Content = styled.div`
  width: ${({ width }: ContentProps) => (width ? width : '80%')};
  padding-top: 36px;
  padding-left: 36px;

  @media (max-width: 768px) and (min-width: 320px) {
    padding: 16px 8px 32px;
  }
  #dfContainer {
    display: flex;
    flex-flow: column;
    align-items: center;
    justify-content: center;
    padding-top: 80px;
    font-family: Avenir;
  }
  #dfImage {
    max-width: 84px;
    opacity: 0.7;
  }
  #dfTitle {
    font-size: 18px;
    font-weight: bold;
    margin-top: 12px;
    margin-bottom: 8px;
  }
  #dfSubtitle {
    font-size: 15px;
  }
`
interface StyleProps {
  showChildren?: boolean
  color?: string
}

export const BackButton = styled.div`
  position: absolute;
  left: 12px;
  font-size: 12px;
  font-weight: normal;
  color: ${BLUE};
  border: 1px solid ${BLUE};
  border-radius: 25px;
  padding: 0 4px;
  padding-right: 8px;
  line-height: 2;
  opacity: 0.8;
  z-index: 4;
`

export const FiltersTitle = styled.div`
  display: ${({ showChildren }: StyleProps) =>
    showChildren ? 'inline-block' : 'none'};
  height: 36.95px;
  color: ${GRAY_DARK};
  font-size: 20px;
  font-weight: bold;
  line-height: 27px;
  margin-bottom: 15px;
  ${({ color }: StyleProps) => `color: ${color};`};
`

export const Title = styled.div`
  color: ${GRAY_DARK};
  font-size: 20px;
  font-weight: 600;
  line-height: 27px;
  display: flex;
  align-items: center;
`

interface ScreenTitleProps {
  show?: boolean
}
export const ScreenTitle = styled.div`
  color: ${GRAY_DARK};
  display: ${({ show }: ScreenTitleProps) => (show ? 'block' : 'none')};
  font-size: 18px;
  font-weight: 600;
  line-height: 27px;
  margin-bottom: 64px;

  @media (max-width: 768px) and (min-width: 320px) {
    margin-bottom: 38px;
    margin-top: 16px;
    display: ${({ show }: ScreenTitleProps) => (show ? 'flex' : 'none')};
    align-items: center;
    justify-content: center;
  }
  @media (max-width: 320px) {
    flex-flow: column;
    margin-top: 0;
    #single {
      position: unset;
      margin-bottom: 8px;
      align-self: flex-start;
    }
  }
`

export const ScreenTitleDescription = styled.div`
  color: ${BLACK};
  font-size: 14px;
  font-weight: normal;
  line-height: 17px;
  margin-top: 10px;

  @media (max-width: 768px) and (min-width: 320px) {
    margin-bottom: 38px;
  }
`

export const menuStyle = { width: '100%', marginLeft: -24, paddingTop: 52 }

export const menuDeviceStyle = { width: '100%' }

export const DrawerSidebar = styled.div`
  .ant-menu-item {
    padding-left: 24px !important;
  }
  .ant-menu-item-custom {
    padding-left: 0 !important;
  }
  .ant-menu-submenu-title {
    padding-left: 0 !important;
  }
`

export const ManagerSection = styled.div`
  width: 100%;
  font-weight: normal;
  text-transform: none;
  line-height: normal;
  text-align: left;
  margin-top: 14px;
  font-size: 12px;
  margin-bottom: -46px;
`

export const ManagerDiv = styled.div`
  display: flex;
  margin-bottom: 6px;
  flex-wrap: wrap;
`

export const ManagerValue = styled.div`
  font-weight: bold;
  font-family: Avenir;
  margin-left: 6px;
  color: ${GRAY_DARK};
`

export const ManagerDirect = styled.div``

export const PhoneManager = styled.a`
  color: ${BLUE};
  font-weight: bold;
  font-family: Avenir;
  margin-left: 6px;
`

export const EmailDiv = styled.div`
  width: 100%;
  margin-top: 2px;
`

export const EmailManager = styled.a`
  color: ${BLUE};
  margin-left: 6px;
`

export const TitleValue = styled.div`
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
  width: fit-content;
  margin: 0 auto;
  margin-bottom: -22px;
`

export const TitleIcon = styled.img`
  max-width: 34px;
  margin-bottom: 12px;
  opacity: 0.7;
`

export const ResellerTag = styled.img`
  max-width: 56px;
  margin-left: 22px;
  border-radius: 3px;
  opacity: 0.7;
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/screens/Account/styledComponents.tsx